<hum-icon icon="share" size="24" class="icon"></hum-icon>
<div class="text">{{ 'sharing.sharing_button' | translate }}</div>
